import { render, staticRenderFns } from "./OrganizationUser.vue?vue&type=template&id=a5ef6bc4&"
import script from "./OrganizationUser.vue?vue&type=script&lang=ts&"
export * from "./OrganizationUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports